/* Gravity "innovaccer gravity" wordmark + arrow mark, exported as a 4× PNG from
   the Figma source (node 723:13240). The "gravity" wordmark uses PolySans Bulky
   and "innovaccer" uses Sofia Pro Black — neither weight ships in the Seasons
   @font-face set — so the lockup is rendered as a transparent image rather than
   live text, matching the FlowLogo / GalaxyLogo approach. Transparent background
   sits cleanly on the translucent-white Gravity nav and the limestone footer. */
export function GravityLogo({ height = 40, className }: { height?: number; className?: string }) {
  return (
    <img
      src="/media/gravity/logo-gravity-wordmark.png"
      alt="innovaccer gravity"
      className={className}
      style={{ height, width: 'auto', display: 'block' }}
      draggable={false}
    />
  )
}

export default GravityLogo
